import { useCallback, useEffect, useState } from "react";
import ContentsTopHeader from "../../../components/common/contents.top.header";
import { UserListContainer } from "../../../style/contents/backup/backup";
import { fetchBackupUserListLoad } from "../../../api/admin";
import UserTableList from "../../../components/user/user.table.list";

export interface UserProfile {
  userId: number;
  isPreview?: boolean;
  userAccount: string;
  userName: string;
  userEmail?: string; // 선택적: ""
  password: string;
  isAdmin: boolean;
  companyId: number;
  macAddress: string[]; // 배열
  phoneNumber?: string; // 선택적: ""
  department?: string; // 선택적: ""
  jobPosition?: string; // 선택적: "과장" 포함 가능
  createdDate?: string; // 선택적: "2025-07-16 12:49:46.795483"
}

type UserListType = UserProfile[];

// 임시 화면 테스트: false로 변경하면 서버 데이터만 표시합니다.
const ENABLE_USER_PREVIEW = false;
const PREVIEW_USER_COUNT = 50;

const addPreviewUsers = (users: UserListType): UserListType => {
  if (
    !ENABLE_USER_PREVIEW ||
    !users.length ||
    users.length >= PREVIEW_USER_COUNT
  )
    return users;

  const firstPreviewId = Math.min(0, ...users.map((user) => user.userId)) - 1;
  const previews = Array.from(
    { length: PREVIEW_USER_COUNT - users.length },
    (_, index) => {
      const source = users[index % users.length];
      const number = String(index + 1).padStart(2, "0");
      return {
        ...source,
        userId: firstPreviewId - index,
        userAccount: `preview_user_${number}`,
        userName: `${source.userName || "구성원"} (테스트 ${number})`,
        userEmail: `preview${number}@example.com`,
        password: "",
        isPreview: true,
      };
    },
  );
  return [...users, ...previews];
};

const UserList = () => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageSize, setPageSize] = useState("10");
  const [data, setData] = useState<UserListType>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = (keyword: string) => {
    setSearchKeyword(keyword);
    // TODO: fetchData(keyword, pageSize);
  };

  const handlePageSizeChange = (size: string) => {
    setPageSize(size);
    // TODO: fetchData(searchKeyword, size);
  };

  const loadUserList = useCallback(async () => {
    setIsLoading(true); // ✅ 로딩 시작
    try {
      const userId = localStorage.getItem("userId");
      const companyCode = localStorage.getItem("companyCode");

      const response = await fetchBackupUserListLoad(
        Number(userId),
        companyCode || "",
      );
      setData(addPreviewUsers(response.userList || []));
    } catch (err) {
      console.error("🚨 사용자 목록 불러오기 실패:", err);
    } finally {
      setIsLoading(false); // ✅ 로딩 종료
    }
  }, []);

  useEffect(() => {
    loadUserList();
  }, [loadUserList]);

  const normalizedKeyword = searchKeyword.trim().toLowerCase();
  const filteredData = data.filter((user) => {
    const keyword = normalizedKeyword;

    const isAdminText = user.isAdmin ? "관리자" : "사용자";

    return (
      user.userAccount.toLowerCase().includes(keyword) ||
      user.userName.toLowerCase().includes(keyword) ||
      user.department?.toLowerCase().includes(keyword) ||
      user.jobPosition?.toLowerCase().includes(keyword) ||
      user.userEmail?.toLowerCase().includes(keyword) ||
      isAdminText.includes(keyword) // ✅ 권한 정보 포함
    );
  });

  return (
    <UserListContainer className="member-list-page">
      {" "}
      <ContentsTopHeader
        title="구성원 목록"
        onSearch={handleSearch}
        onPageSizeChange={handlePageSizeChange}
        className="user-list-top-header"
        pageSizeHidden
      />
      <div className="contents-body">
        <UserTableList
          data={filteredData}
          pageSize={parseInt(pageSize)}
          paginationEnabled={false}
          onUpdateSuccess={loadUserList} // ✅ 수정 성공 후 갱신용
          isLoading={isLoading}
        />
      </div>
    </UserListContainer>
  );
};

export default UserList;
